export function Button({ variant = 'default', block, primary, danger, children, ...rest }) {
  const v = variant !== 'default' ? variant : primary ? 'primary' : danger ? 'danger' : 'default';
  const cls = ['btn', v !== 'default' && v, block && 'block'].filter(Boolean).join(' ');
  return (
    <button class={cls} {...rest}>
      {children}
    </button>
  );
}
